/* Promo-Leiste: wechselt zwischen mehreren Hinweisen, laesst sich anhalten, mobil per Wischen. */

/*
  Wer von Hand angehalten hat, will nicht auf der naechsten Seite wieder von vorn anfangen.
  Nur fuer die Sitzung — beim naechsten Besuch laeuft die Leiste wieder.
*/
const HALT_KEY = 'kgroup:promo-angehalten';

function liesHalt() {
  try {
    return sessionStorage.getItem(HALT_KEY) === '1';
  } catch {
    return false;
  }
}

function schreibHalt(an) {
  try {
    if (an) sessionStorage.setItem(HALT_KEY, '1');
    else sessionStorage.removeItem(HALT_KEY);
  } catch {
    /* Speicher gesperrt */
  }
}

class KgAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.announcement-bar__item')];
    this.index = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
    this.interval = Number(this.dataset.interval) || 5000;

    /*
      Ein Hinweis kann auf „nur Handy" oder „nur Rechner" stehen. Traegt gerade der erste die
      falsche Wahl, stuende die Leiste bis zum ersten Wechsel leer — deshalb hier gleich auf
      den ersten gezeigten springen, vor allem anderen.
    */
    if (this.items.length && !this.wirdGezeigt(this.items[this.index])) this.go(this.naechster(1));
    if (this.items.length < 2) return;

    /*
      Beim Wechsel der Breite kann der gerade gezeigte Hinweis verschwinden. Ohne das hier
      blieb die Leiste bis zum naechsten Takt leer — und stand sie still, weil nur einer
      uebrig war, bliebe sie es auf Dauer.
    */
    this.onResize = () => {
      cancelAnimationFrame(this.resizeTakt);
      this.resizeTakt = requestAnimationFrame(() => {
        if (!this.wirdGezeigt(this.items[this.index])) this.go(this.naechster(1));
        this.pruefen();
      });
    };
    window.addEventListener('resize', this.onResize);

    this.addEventListener('pointerdown', (event) => {
      this.swipeStart = event.pointerType === 'mouse' ? null : event.clientX;
      this.gewischt = false;
    });
    this.addEventListener('pointerup', (event) => {
      if (this.swipeStart === null || this.swipeStart === undefined) return;
      const delta = event.clientX - this.swipeStart;
      this.swipeStart = null;
      if (Math.abs(delta) < 40) return;
      /* Nach einem Wisch folgt noch ein click — der darf dem Link nicht folgen. */
      this.gewischt = true;
      this.go(this.naechster(delta < 0 ? 1 : -1), true);
    });

    /*
      Die ganze Leiste folgt dem Link des gezeigten Hinweises, nicht nur die Worte. Der Link
      bleibt als `<a>` stehen: Tastatur, Vorlesegeraet und Mittelklick brauchen ihn, und mit
      gedrueckter Sondertaste will man ohnehin den Text treffen. Hier wird nur die Flaeche
      daneben nachgezogen — Pausenknopf, Links und die Code-Pille bleiben fuer sich.
    */
    this.addEventListener('click', (event) => {
      if (this.gewischt || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.target.closest('a, button, kg-copy')) return;
      this.items[this.index]?.querySelector('.announcement-bar__link')?.click();
    });
    /*
      Vier Anlaesse koennen die Uhr anhalten: Zeiger darueber, Fokus darin, Tab im Hintergrund
      und der Knopf. Jeder setzt nur seinen Merker, entschieden wird an einer einzigen Stelle.
      Ein direkter Aufruf von start() oder stop() je Anlass waere nicht tragfaehig, sobald zwei
      sich widersprechen: Wer den Knopf drueckt und dann die Maus wegzieht, bekaeme durch
      `pointerleave` den Lauf zurueck.
    */
    this.addEventListener('pointerenter', () => this.merke('beruehrt', true));
    this.addEventListener('pointerleave', () => this.merke('beruehrt', false));
    /*
      Der Fokus haelt an, damit man einen Hinweis in Ruhe lesen und seinen Link treffen kann —
      der Pause-Knopf selbst ist davon ausgenommen. Sonst bliebe die Leiste nach dem Tippen auf
      „fortsetzen" stehen, solange der Knopf den Fokus hat: Das Symbol zeigte den Lauf an, und
      nichts bewegte sich. Auf dem Handy bleibt der Fokus nach einem Tipp liegen, dort waere das
      sofort aufgefallen.
    */
    this.addEventListener('focusin', (event) => this.merke('fokus', !this.knopf?.contains(event.target)));
    this.addEventListener('focusout', () => this.merke('fokus', false));
    this.onVisibility = () => this.pruefen();
    document.addEventListener('visibilitychange', this.onVisibility);

    this.knopf = this.querySelector('[data-promo-pause]');
    this.vonHand = Boolean(this.knopf) && liesHalt();
    if (this.knopf) {
      this.knopf.addEventListener('click', () => this.umschalten());
      this.zeigeZustand();
    }

    if (window.Shopify?.designMode) {
      this.onBlockSelect = (event) => {
        const index = this.items.indexOf(event.target);
        if (index === -1) return;
        this.go(index);
        this.merke('editor', true);
      };
      this.onBlockDeselect = () => this.merke('editor', false);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    this.pruefen();
  }

  /* Was auf dieser Breite ueberhaupt angezeigt wird — die Geraetewahl steckt im Blatt. */
  wirdGezeigt(item) {
    return getComputedStyle(item).display !== 'none';
  }

  anzahlGezeigt() {
    return this.items.filter((item) => this.wirdGezeigt(item)).length;
  }

  /* Naechster gezeigter Hinweis in einer Richtung, hoechstens eine Runde weit. */
  naechster(richtung) {
    const anzahl = this.items.length;
    for (let schritt = 1; schritt <= anzahl; schritt += 1) {
      const i = (((this.index + richtung * schritt) % anzahl) + anzahl) % anzahl;
      if (this.wirdGezeigt(this.items[i])) return i;
    }
    return this.index;
  }

  disconnectedCallback() {
    this.stop();
    cancelAnimationFrame(this.resizeTakt);
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('visibilitychange', this.onVisibility);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
  }

  merke(name, wert) {
    this[name] = wert;
    this.pruefen();
  }

  /* Eine Stelle entscheidet, ob die Uhr laeuft. Sonst widersprechen sich die Anlaesse. */
  pruefen() {
    /*
      Bleibt auf dieser Breite nur ein Hinweis uebrig, wechselt nichts — dann hat auch der
      Knopf nichts anzuhalten. Die Section kann das nicht wissen: Sie kennt die Breite nicht.
    */
    const mehrere = this.anzahlGezeigt() > 1;
    if (this.knopf) this.knopf.hidden = !mehrere;
    const darf =
      mehrere &&
      !this.vonHand &&
      !this.beruehrt &&
      !this.fokus &&
      !this.editor &&
      !document.hidden &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.stop();
    if (darf) this.timer = setInterval(() => this.go(this.naechster(1)), this.interval);
  }

  stop() {
    clearInterval(this.timer);
    /* Zurueckgesetzt, damit „laeuft die Uhr?" am Objekt ablesbar bleibt und nicht nur im Timer. */
    this.timer = null;
  }

  umschalten() {
    this.vonHand = !this.vonHand;
    schreibHalt(this.vonHand);
    this.zeigeZustand();
    this.pruefen();
  }

  /*
    Der Zustand steht in der Beschriftung, nicht nur im Symbol: Wer vorlesen laesst, hoert
    sonst „anhalten", waehrend die Leiste laengst steht.
  */
  zeigeZustand() {
    this.toggleAttribute('data-angehalten', this.vonHand);
    const { labelPause, labelPlay } = this.knopf.dataset;
    this.knopf.setAttribute('aria-label', this.vonHand ? labelPlay : labelPause);
    this.knopf.querySelector('[data-promo-icon-pause]').toggleAttribute('hidden', this.vonHand);
    this.knopf.querySelector('[data-promo-icon-play]').toggleAttribute('hidden', !this.vonHand);
  }

  go(index, restart = false) {
    this.index = (index + this.items.length) % this.items.length;
    this.items.forEach((item, i) => {
      const active = i === this.index;
      item.classList.toggle('is-active', active);
      if (active) item.removeAttribute('aria-hidden');
      else item.setAttribute('aria-hidden', 'true');
    });
    /*
      Nach dem Wischen laeuft die Uhr von vorn — es sei denn, jemand hat angehalten. Darum
      hier pruefen() und nicht einfach neu starten.
    */
    if (restart) this.pruefen();
  }
}

customElements.define('kg-announcement-bar', KgAnnouncementBar);
